import React from 'react';

export const MagicWand = props => (
  <svg width="201px" height="162px" viewBox="0 0 201 162" version="1.1">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-1293.000000, -286.000000)">
        <g transform="translate(1293.000000, 286.000000)">
          <path
            d="M148.569827,153.828286 L52.4303682,153.828286 L0.508570047,101.847549 C-0.169523349,101.168692 -0.169523349,100.057914 0.508570047,99.3790569 L99.2670336,0.508488428 C99.9459986,-0.169496143 101.054655,-0.169496143 101.732749,0.508488428 L200.492084,99.3790569 C201.169305,100.057914 201.169305,101.168692 200.492084,101.847549 L148.569827,153.828286 Z"
            fill="#F3F4F6"
            fillRule="nonzero"
          />
          <path
            d="M126.1069,84.9858 C123.0059,84.2198 119.7409,86.1458 117.7369,94.2578 C116.4279,99.5618 115.4479,106.6838 115.8839,110.3718 C115.4969,110.2758 115.4109,110.1968 114.7429,110.1968 C113.9789,110.1968 113.7689,110.2868 113.3299,110.4098 C113.8219,106.7688 113.5109,102.4668 112.6339,98.4478 C111.2529,92.1188 106.1299,84.1558 102.1579,85.1218 C98.1859,86.0878 99.1749,96.3618 101.1519,101.5858 C103.3699,107.4408 104.8619,109.6918 107.6329,112.6928 C105.4139,114.5058 104.0069,117.1448 104.0069,120.0938 C104.0069,125.5598 108.8139,129.9908 114.7429,129.9908 C120.6709,129.9908 125.4779,125.5598 125.4779,120.0938 C125.4779,117.1448 124.0709,114.5058 121.8509,112.6918 C123.2739,111.0658 124.7669,108.4358 126.0729,105.4618 L127.4029,102.1338 C128.0229,100.4258 128.5579,98.6898 128.9669,97.0308 C130.9709,88.9188 129.2079,85.7518 126.1069,84.9858"
            fill="#FFFFFF"
          />
          <path
            d="M127.8379,100.8901 C128.2749,99.5901 128.6569,98.2871 128.9669,97.0311 C130.9709,88.9181 129.2079,85.7511 126.1069,84.9861 C123.0059,84.2201 119.7409,86.1461 117.7369,94.2581 C116.4279,99.5621 115.4479,106.6841 115.8839,110.3711 C115.4969,110.2761 115.4109,110.1971 114.7429,110.1971 C113.9789,110.1971 113.7689,110.2861 113.3299,110.4101 C113.8219,106.7691 113.5109,102.4671 112.6339,98.4481 C111.2539,92.1191 106.1299,84.1561 102.1579,85.1211 C100.5929,85.5011 99.7979,87.3271 99.5299,89.7181"
            stroke="#D62793"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M99.5635,94.4311 C99.8225,97.0221 100.4195,99.6511 101.1525,101.5851 C103.3695,107.4411 104.8625,109.6921 107.6325,112.6931 C105.4135,114.5051 104.0075,117.1451 104.0075,120.0941 C104.0075,125.5601 108.8135,129.9911 114.7425,129.9911 C120.6715,129.9911 125.4775,125.5601 125.4775,120.0941 C125.4775,117.1451 124.0705,114.5051 121.8515,112.6921 C123.0475,111.3251 124.2945,109.2451 125.4385,106.8491"
            stroke="#8230DF"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M135.5908,157.7201 C135.5908,160.0301 126.2838,161.9021 114.8038,161.9021 C103.3238,161.9021 94.0178,160.0301 94.0178,157.7201 C94.0178,155.4091 103.3238,153.5371 114.8038,153.5371 C126.2838,153.5371 135.5908,155.4091 135.5908,157.7201"
            fill="#D0D7DA"
          />
          <path
            d="M110.3511,100.9164 C111.7311,106.2904 112.1211,110.1124 110.2581,110.5104 C108.3951,110.9074 106.7881,108.0434 105.9271,104.8274 C105.0661,101.6104 107.5651,93.8424 107.5651,93.8424 C107.5651,93.8424 108.9701,95.5434 110.3511,100.9164"
            fill="#F3F4F6"
          />
          <g transform="translate(91.000000, 113.710000)">
            <path
              d="M0.0181,16.9164 L0.0181,34.1104 C0.0181,38.6914 3.7311,42.4054 8.3131,42.4054 L39.4191,42.4054 C44.0001,42.4054 47.7141,38.6914 47.7141,34.1104 L47.7141,0.9314 L0.0181,0.9314 L0.0181,9.9644"
              fill="#FFFFFF"
            />
            <path
              d="M0.0181,16.9164 L0.0181,34.1104 C0.0181,38.6914 3.7311,42.4054 8.3131,42.4054 L39.4191,42.4054 C44.0001,42.4054 47.7141,38.6914 47.7141,34.1104 L47.7141,0.9314 L0.0181,0.9314 L0.0181,9.9644"
              stroke="#7350A0"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <path
            d="M123.5332,144.4018 L92.0182,144.4018"
            stroke="#F2C217"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M136.9517,147.3901 C136.9517,151.5811 130.1697,153.9641 130.1697,153.9641 L130.1697,116.2591 L136.9517,116.2591 L136.9517,147.3901 Z"
            fill="#F2F3F3"
          />
          <path
            d="M137.7139,144.4018 L127.1809,144.4018"
            stroke="#F2C217"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M143.54,153.5375 L175.285,153.5375"
            stroke="#EB1D26"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M87.4536,153.5375 L33.6976,153.5375"
            stroke="#EB1D26"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M23.6978,153.5375 L15.6618,153.5375"
            stroke="#EB1D26"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M72.981,74.5883 L72.981,76.5883"
            stroke="#5EDAB0"
            strokeLinecap="round"
          />
          <path
            d="M72.981,80.5883 L72.981,82.5883"
            stroke="#5EDAB0"
            strokeLinecap="round"
          />
          <path
            d="M76.981,78.5883 L74.981,78.5883"
            stroke="#5EDAB0"
            strokeLinecap="round"
          />
          <path
            d="M70.981,78.5883 L68.981,78.5883"
            stroke="#5EDAB0"
            strokeLinecap="round"
          />
          <path
            d="M121.7754,65.1225 L121.7754,67.1225"
            stroke="#ED0722"
            strokeLinecap="round"
          />
          <path
            d="M121.7754,71.1225 L121.7754,73.1225"
            stroke="#ED0722"
            strokeLinecap="round"
          />
          <path
            d="M125.7754,69.1225 L123.7754,69.1225"
            stroke="#ED0722"
            strokeLinecap="round"
          />
          <path
            d="M119.7754,69.1225 L117.7754,69.1225"
            stroke="#ED0722"
            strokeLinecap="round"
          />
          <path
            d="M104.043,60.5219 C104.043,61.3599 103.363,62.0399 102.525,62.0399 C101.687,62.0399 101.007,61.3599 101.007,60.5219 C101.007,59.6839 101.687,59.0039 102.525,59.0039 C103.363,59.0039 104.043,59.6839 104.043,60.5219"
            fill="#F5C400"
          />
          <path
            d="M81.77,98.1947 C81.77,99.0337 81.09,99.7127 80.252,99.7127 C79.414,99.7127 78.734,99.0337 78.734,98.1947 C78.734,97.3567 79.414,96.6767 80.252,96.6767 C81.09,96.6767 81.77,97.3567 81.77,98.1947"
            fill="#AA81F7"
          />
          <polygon
            fill="#FFFFFF"
            points="128.862 143.881 137.601 143.881 137.601 141.938 128.862 141.938"
          />
          <path
            d="M75.981,23.8549 C75.981,23.8549 83.005,81.5879 36.635,97.6209"
            stroke="#DCE4E7"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <polygon
            stroke="#DCE4E7"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="15.323 104.651 36.635 104.651 36.635 97.621 15.323 97.621"
          />
          <path
            d="M36.0151,105.4233 C36.0151,105.4233 47.1351,123.6743 47.1351,148.4713"
            stroke="#DCE4E7"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M15.1709,85.6645 L15.1709,114.6415"
            stroke="#DCE4E7"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M33.2529,91.9779 C33.2529,91.9779 50.9509,73.1229 47.1349,52.7009"
            stroke="#DCE4E7"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <polygon
            fill="#FFFFFF"
            points="77.0488 59.6195 78.6478 56.9725 87.0418 62.0425 85.4428 64.6895"
          />
          <polygon
            stroke="#391572"
            points="77.0488 59.6195 78.6478 56.9725 87.0418 62.0425 85.4428 64.6895"
          />
          <polygon
            fill="#8230DF"
            points="48.9009 42.6147 50.5009 39.9677 78.6479 56.9717 77.0489 59.6197"
          />
          <polygon
            stroke="#391572"
            strokeLinecap="round"
            points="48.9009 42.6147 50.5009 39.9677 78.6479 56.9717 77.0489 59.6197"
          />
          <path
            d="M106.127,92.0141 C106.127,92.0141 108.263,93.5851 110.136,100.1311 C112.008,106.6771 111.027,109.7651 111.027,109.7651"
            stroke="#DDE5E8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M119.0596,100.9164 C117.6786,106.2904 117.2886,110.1124 119.1526,110.5104 C121.0156,110.9074 122.6226,108.0434 123.4836,104.8274 C124.3446,101.6104 121.8456,93.8424 121.8456,93.8424 C121.8456,93.8424 120.4396,95.5434 119.0596,100.9164"
            fill="#F3F4F6"
          />
          <path
            d="M123.2832,92.0141 C123.2832,92.0141 121.1472,93.5851 119.2742,100.1311 C117.4022,106.6771 118.3832,109.7651 118.3832,109.7651"
            stroke="#DDE5E8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M30.8198,110.4096 C30.8198,110.4096 37.0768,124.5496 36.0148,137.3506"
            stroke="#DCE4E7"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M78.0039,153.6479 L28.2479,153.6479"
            stroke="#EB1D26"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M18.248,153.6479 L10.211,153.6479"
            stroke="#EB1D26"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
    </g>
  </svg>
);
